<template>
  <div class="columns">
    <div class="column"></div>
    <div class="column is-one-third-desktop is-two-thirds-tablet">
      <settings-contents></settings-contents>
    </div>
    <div class="column"></div>
  </div>
</template>

<script>
import SettingsContents from "@/components/SettingsContents.vue";

export default {
  name: "settings",
  components: {
    "settings-contents": SettingsContents
  }
};
</script>
